/**
 * What: Shared fork-lineage contract for Shopify "New version" setup forks (issue #1143, Phase 1).
 * Transport / data-flow: Pure type + value list imported by the Worker proxy (src) and the embedded
 *   app UI (app) so the authored "what changed" reason has one owner across the boundary. Mirrors the
 *   TestFeed Worker zod contract in apps/web/src/lib/integrations/shopify-setup-packet-contract.ts.
 *
 */

/** Authored merchant answer for why a setup was forked into a new version. */
export type ShopifyForkChangeReason = 'changed_stimulus' | 'changed_audience' | 'changed_method' | 'other'

/** Ordered set of valid fork-change reasons; the merchant must pick exactly one (no silent default). */
export const SHOPIFY_FORK_CHANGE_REASONS: readonly ShopifyForkChangeReason[] = [
  'changed_stimulus',
  'changed_audience',
  'changed_method',
  'other',
]

/** Narrows an unknown value to a valid fork-change reason. */
export function isShopifyForkChangeReason(value: unknown): value is ShopifyForkChangeReason {
  return typeof value === 'string' && (SHOPIFY_FORK_CHANGE_REASONS as readonly string[]).includes(value)
}
